import React, { useEffect, useState } from "react";
import { Page, PendingButton } from "components/common";
import { SalesTaxContainer } from "./components";
import moment from "moment";
import { Nav, NavItem, NavLink, FormGroup, Label, Input } from "reactstrap";
import classnames from "classnames";
import { Trans } from "react-i18next";
import DatePicker from "react-datepicker";
import { NotificationManager } from "react-notifications";
import ReportsSettings from "./ReportsSettings";

const SalesTaxReport = ({ client, t, selectedOrganisation }) => {
  const [item, setItem] = useState({
    fromDate: moment().startOf("month").format("YYYY-MM-DD"),
    toDate: moment().endOf("month").format("YYYY-MM-DD"),
    isAudit: false,
    showByRate: false,
    showByComponent: true,
    showByAccount: false,
  });
  const [data, setData] = useState(null);
  const [pending, setPending] = useState(false);
  const [isError, setIsError] = useState(false);
  const [settings, setSettings] = useState(null);

  const xeroLink = `https://go.xero.com/Setup/FinancialSettings.aspx`;

  useEffect(() => {
    setData(null)
  }, [item.isAudit]);

  const loadReport = async () => {
    setPending(true);
    try {
      let resp = await client
        .get(`xero_actions/${selectedOrganisation.id}/sales_tax_report`, {
          params: item,
        })
        .get("data");
      setData(resp);
    } catch (ex) {
      if (ex.response && ex.response.data) {
        setIsError(true);
        NotificationManager.error(t(ex.response.data));
      } else {
        NotificationManager.error(t("An unexpected error occurred"));
      }
    }
    setPending(false);
  };

  return (
    <Page title="Sales Tax Report" className="inv-table">
      <div className="d-print-none inv-tabs ">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: !item.isAudit })}
              href="##"
              onClick={(e) => {
                e.preventDefault();
                setData(null);
                let newItem = { ...item, isAudit: false };
                setItem(newItem);
              }}
            >
              <Trans>Sales Tax Summary</Trans>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: !!item.isAudit })}
              href="##"
              onClick={(e) => {
                e.preventDefault();
                setData(null);
                let newItem = { ...item, isAudit: true };
                setItem(newItem);
              }}
            >
              <Trans>Sales Tax Audit Report</Trans>
            </NavLink>
          </NavItem>
        </Nav>

        <div className="d-flex justify-content-between mt-3">
          <div className="d-flex">
            <FormGroup className="mr-3">
              <Label>
                <Trans>From Date</Trans>
              </Label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={item.fromDate ? moment(item.fromDate) : null}
                className="form-control"
                dateFormat="D MMM YYYY"
                onChange={(value) => {
                  const m = moment(value);
                  let newItem = { ...item };
                  newItem.fromDate = m.isValid ? m.format("YYYY-MM-DD") : null;
                  setItem(newItem);
                }}
              />
            </FormGroup>
            <FormGroup className="mr-3">
              <Label>
                <Trans>To Date</Trans>
              </Label>
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                selected={item.toDate ? moment(item.toDate) : null}
                className="form-control"
                dateFormat="D MMM YYYY"
                onChange={(value) => {
                  const m = moment(value);
                  let newItem = { ...item };
                  newItem.toDate = m.isValid ? m.format("YYYY-MM-DD") : null;
                  setItem(newItem);
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label>&nbsp;</Label>
              <PendingButton
                color="primary"
                size="sm"
                className="d-block"
                onClick={loadReport}
                pending={pending}
              >
                <Trans>Update</Trans>
              </PendingButton>
            </FormGroup>
          </div>
          <ReportsSettings setSettings={setSettings} settings={settings} isPartial={true} />
        </div>
        {!item.isAudit && (
          <div className="mt-2">
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={item.showByRate}
                  onChange={(x) =>
                    setItem({ ...item, showByRate: x.target.checked })
                  }
                />{" "}
                <Trans key="trans">Show by Tax Rate</Trans>
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={item.showByComponent}
                  onChange={(x) =>
                    setItem({ ...item, showByComponent: x.target.checked })
                  }
                />{" "}
                <Trans key="trans">Show by Tax Component</Trans>
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  checked={item.showByAccount}
                  onChange={(x) =>
                    setItem({ ...item, showByAccount: x.target.checked })
                  }
                />{" "}
                <Trans key="trans">Show by Account Type</Trans>
              </Label>
            </FormGroup>
            <hr />
          </div>
        )}
      </div>
      {isError ? (
        <div className="text-center">
          <p style={{ color: "grey", marginBottom: '0.2em', fontSize: "1.1em" }}><Trans>The Report Cannot be Displayed.</Trans></p>
          <p style={{ marginBottom: '0.5em' }}>
            <Trans>It seems that you haven't configured your Sales Tax Basis yet.</Trans>
          </p>
          <a
            href={xeroLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#72B566', fontSize: "1.3em" }}
          >
            <Trans>Go to Xero and set up Tax Basis</Trans>
          </a>
        </div>
      ) : null}
      {data ? <SalesTaxContainer report={data} /> : null}
    </Page>
  );
};

export default SalesTaxReport;
